import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import {
  BUSCA_PADRAO,
  MAIS_PROCURADOS_MAX,
  MAIS_PROCURADOS_MIN,
} from './helpers';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_servicos_busca_block',
    defaultMessage: 'Busca de serviços',
  },
  sobretitulo: {
    id: 'mpf_servicos_busca_sobretitulo',
    defaultMessage: 'Texto acima do título',
  },
  titulo: { id: 'mpf_servicos_busca_titulo', defaultMessage: 'Título' },
  tituloPrincipal: {
    id: 'mpf_servicos_busca_titulo_principal',
    defaultMessage: 'Título principal da página',
  },
  tituloPrincipalHelp: {
    id: 'mpf_servicos_busca_titulo_principal_help',
    defaultMessage:
      'Ligado, o título é o h1 da página. Desligue se a página já tiver outro título principal.',
  },
  texto: { id: 'mpf_servicos_busca_texto', defaultMessage: 'Texto de apoio' },
  pasta: {
    id: 'mpf_servicos_busca_pasta',
    defaultMessage: 'Pasta de serviços',
  },
  pastaHelp: {
    id: 'mpf_servicos_busca_pasta_help',
    defaultMessage:
      'De onde vêm as sugestões: categorias e serviços desta Pasta de Serviços.',
  },
  fieldsetAtalhos: {
    id: 'mpf_servicos_busca_fieldset_atalhos',
    defaultMessage: 'Mais procurados',
  },
  maisProcuradosRotulo: {
    id: 'mpf_servicos_busca_mais_procurados_rotulo',
    defaultMessage: 'Rótulo dos atalhos',
  },
  maisProcurados: {
    id: 'mpf_servicos_busca_mais_procurados',
    defaultMessage: 'Serviços',
  },
  maisProcuradosHelp: {
    id: 'mpf_servicos_busca_mais_procurados_help',
    defaultMessage:
      'Escolha de {min} a {max} serviços do catálogo, na ordem em que devem aparecer.',
  },
});

export const mpfServicosBuscaSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['sobretitulo', 'titulo', 'tituloPrincipal', 'texto', 'pasta'],
    },
    {
      id: 'atalhos',
      title: intl.formatMessage(messages.fieldsetAtalhos),
      fields: ['maisProcuradosRotulo', 'maisProcurados'],
    },
  ],
  properties: {
    sobretitulo: {
      title: intl.formatMessage(messages.sobretitulo),
      default: BUSCA_PADRAO.sobretitulo,
    },
    titulo: {
      title: intl.formatMessage(messages.titulo),
      default: BUSCA_PADRAO.titulo,
    },
    tituloPrincipal: {
      title: intl.formatMessage(messages.tituloPrincipal),
      description: intl.formatMessage(messages.tituloPrincipalHelp),
      type: 'boolean',
      widget: 'toggle',
      default: true,
    },
    texto: {
      title: intl.formatMessage(messages.texto),
      widget: 'textarea',
      default: BUSCA_PADRAO.texto,
    },
    pasta: {
      title: intl.formatMessage(messages.pasta),
      description: intl.formatMessage(messages.pastaHelp),
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['PastaServicos'],
      allowExternals: false,
    },
    maisProcuradosRotulo: {
      title: intl.formatMessage(messages.maisProcuradosRotulo),
      default: BUSCA_PADRAO.maisProcuradosRotulo,
    },
    maisProcurados: {
      title: intl.formatMessage(messages.maisProcurados),
      description: intl.formatMessage(messages.maisProcuradosHelp, {
        min: MAIS_PROCURADOS_MIN,
        max: MAIS_PROCURADOS_MAX,
      }),
      widget: 'object_browser',
      mode: 'multiple',
      selectableTypes: ['Servico'],
      selectedItemAttrs: [
        '@id',
        'Title',
        'url',
        'externo',
        'tipo_acesso_govbr',
      ],
      allowExternals: false,
      maximumSelectionSize: MAIS_PROCURADOS_MAX,
    },
  },
  required: [],
});
